// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609020334/js/" + chunkId + "." + {"44":"8ed6ac10","225":"852085c4","481":"ce93b0e8","486":"425ba3f0","770":"0dcab845"}[chunkId] + ".0.6277237069675322.chunk.js";
};